import { useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import {getAllCatalogsNorm ,CreateCatalogs,DeleteCatalogs,UpdateCatalogs} from '../../services/microsanitaria/catalogosMic'


export const useMicCatalogs = () => {
    const [createSweet] = useSweetAlert();
    const [listCatalogs, setListCatalogs] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchListCatalogs, setSearchListCatalogs] = useState([])

    // ? MODAL CRUD
    const [modal, setModal] = useState(false)
    const [tittle, setTittle] = useState("")
    const [method, setMethod] = useState("")
    const [id_mic_norm, setId_mic_norm] = useState(0);
    const [titleDelete, setTitleDelete] = useState("")
    
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);

    // * FORM 
    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name:"",
    });

    const {
        name,description,estatus
    } = formValues;
   
    useEffect(() => {
        getCatalogsNorm()
    }, []);
    
    const getCatalogsNorm = async (_type) =>
        {
            const catalogs = await getAllCatalogsNorm();    

            if (catalogs?.length > 0)
            {
                let startItems = 0;
                let endItems = numberItems;
                let aux = numberItems * currentPage;
                let _new_list = [];

                endItems = aux;
                startItems = endItems - numberItems;

                catalogs.forEach((_find,_key) => {
                    let posicion = _key + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }
                    _new_list.push({
                        id_mic_nom: _find?.id_mic_nom ?? null,
                        name: _find?.name ?? null,
                        description: _find?.description ?? null,
                        estatus: _find?.estatus ?? null,
                        visibleTable: visibleTable,
                    })
                });
                setListCatalogs(_new_list);      
                setSearchListCatalogs(_new_list)        
                setNormaData(_new_list);            
            }
    }

    // const toggle = () => {
    //     setModal(!modal);
    // }

      const openDialog = (title, mode) => {
        // setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);   
    };

    // * CRUD TABLE
    const handleCreate = () => 
    {        
        handleUpdateValues({
            name:"",
        })
        setTittle("Crear Norma")
        setMethod("create")
        openDialog("Crear Norma", "create");
    }

    const saveCreate =async (e) => 
    {
        e.preventDefault();
        
        setLoading(true);
        const response = await CreateCatalogs({
            name: formValues.name,  
            description: formValues.description,  
            estatus: formValues.estatus,  


        });

        if (response.code === 200){
            setLoading(false);
            getCatalogsNorm()
            createSweet("success", "success", "Se a creado correctamente");
            closeDialog();
            handleUpdateValues({
                name:"",
                description:"",
                estatus:false
            })
        } 
    }

    const handleUpdate = (id_mic_nom) => 
    {
        let list = listCatalogs.find(c => c.id_mic_nom === parseInt(id_mic_nom));

        if (list !== "" || list !== null) {

            handleUpdateValues({
                name: list?.name,
                description: list?.description,
                estatus: list?.estatus
            });
            setTittle("Actualizar")
            setId_mic_norm(id_mic_nom)
            setMethod("update")
            openDialog("Modificar Norma", "update");
        }
    }

    const saveUpdateMic = async (e) => 
    {
        e.preventDefault();
        setLoading(true);

        const response = await UpdateCatalogs({
            id_mic_nom: id_mic_norm,
            name: formValues.name,  
            description: formValues.description,  
            estatus: formValues.estatus, 
        });

        if (response.code === 200){
                setLoading(false);
                createSweet("success", "success", "Se a actualizado correctamente");
                getCatalogsNorm()
                closeDialog();
            handleUpdateValues({
                name:"",
                description:"",
                estatus:false
            })
            setId_mic_norm(0);
        } 
    }

    const handleDelete = (id_mic_nom,_name) => 
    {
        let list = listCatalogs.find(c => c.id_mic_nom === parseInt(id_mic_nom));

        if (list !== "" || list !== null) {

            handleUpdateValues({
                name: list?.name,
                description: list?.description,
                estatus: list?.estatus
            });
            setTitleDelete(list.name)
            setId_mic_norm(id_mic_nom)
            setMethod("delete")
            openDeleteAlert();
            setTittle("Eliminar")

        }
    }

    const saveDeleteMic= async (e) => 
    {
        e.preventDefault();
    
        setLoading(true);
    
        const response = await DeleteCatalogs({
            id_mic_nom  : id_mic_norm
        });
    
        if (response.code === 200){
            setLoading(false);
            createSweet("success", "success", "Se a eliminado correctamente");
            closeDeleteAlert();
            setShowDeleteAlert(false);
            getCatalogsNorm()
            handleUpdateValues({
                name:"",
            })
            setId_mic_norm(0);
        } 
    }

    // ? PAGINATION 
    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(listCatalogs.length, numberItems);

    useEffect(() => {

        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;

        let listcompanies = [];
        listCatalogs.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listcompanies.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setListCatalogs(listcompanies);

    }, [totalPageCount, currentPage]);
   
    // ? SEARCH TYPE DISCOUNT
    const handleSearchDiscount = (e) => {

        let busqueda = e.target.value;
        let newMethod = [];

        searchListCatalogs.forEach(element => {

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setListCatalogs(newMethod);
    }

    const [normaData, setNormaData] = useState([]);
    const [searchNarma, setSearchNorma] = useState("");

     const handleSearch = (e) => {
        setSearchNorma(e);

        let busqueda = e.toUpperCase();
        let newTypeSample = [];

        if (busqueda === "") {
            setListCatalogs([...normaData]);
        } else {
            normaData.forEach(element => {

                let name = element.name?.toUpperCase() || "";
                let description = element.description?.toUpperCase() || "";

                if (
                    name.indexOf(busqueda) > -1 ||
                    description.indexOf(busqueda) > -1
                ) {
                    element.visibleTable = true;
                    newTypeSample.push(element);
                }
            });

            setListCatalogs([...newTypeSample]);
            
        }
    };

    const handleClear = () => {
        setSearchNorma("");                         
        localStorage.removeItem("globalFilter");    
        setListCatalogs(normaData);                    
    };

    const handleExportNorma = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

          const _report = listCatalogs.map((item, index) => ({
                "#": index + 1,
                Nombre: item.name ?? "---",
                Descripción: item.description ?? "---",
                Vigente: item.estatus === true ? "Sí" : "No"

            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Listado de Normas");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Catálogo_Normas.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };



    return {
         // * LIST
         listCatalogs,

        // * PAGINATION
        totalPageCount, currentPage, nextPage, previousPage, goToPage,handleSearchDiscount,

        //* CRUD TABLE
        handleCreate,handleUpdate,handleDelete,closeDialog,method,modal,tittle,
        name,handleInputChange,titleDelete,description,estatus,
        saveCreate,saveUpdateMic,saveDeleteMic,loading,

        showDeleteAlert, modalAlert, closeDeleteAlert,handleExportNorma, loadingExport,
        handleClear, handleSearch, searchNarma, 

    }
}




